'use strict';

/**
 * Source attribution structure example:
 * [
 *     {
 *         "type": "TYPE",
 *         "date": "2016-08-03T16:56:26.000+03:00",
 *         "time": 1470232586378,
 *         "referer": "https://www.1stdibs.com/furniture/"
 *         "utmParams": {
 *             "landingPage": "/furniture/tables/",
 *             "visitCount": 1
 *         }
 *     }
 * ]
 */

const User = require('../models/User');
const moment = require('moment');
const endpoints = require('dibs-endpoints');
const windowCheck = require('bunsen/helpers/windowCheck');
const {localStorage} = require('dibs-browser-storage');
const serviceFetchWrappers = require('dibs-service-fetch-wrappers/dist/util');

const SETTINGS = {
    DATE_FORMAT: 'YYYY-MM-DDTHH:mm:ss.SSSZ',

    PRE_REGISTRATION_PAGE_VISIT: {
        CAP: 100,
        STORAGE_KEY: '_dibsPreRegistrationPageVisit'
    }
};

const getStorageKey = type => {
    const {STORAGE_KEY} = SETTINGS[type] || {};
    return STORAGE_KEY || '';
};

const getCAP = type => {
    const {CAP} = SETTINGS[type] || {};
    return CAP;
};

const getDateTime = () => {
    const now = new Date();

    return {
        date: moment(now.toISOString()).format(SETTINGS.DATE_FORMAT),
        time: now.getTime()
    };
};

const generateAttribution = ({type, page}) => {
    return Object.assign(getDateTime(), {
        type,
        utmParams: {
            landingPage: page,
            visitCount: 1
        }
    });
};

const sortAttribution = (a, b) => {
    if (a.time < b.time) {
        return 1;
    } else if (a.time > b.time) {
        return -1;
    }

    return 0;
};

const getAttribution = type => {
    return localStorage.getItem(getStorageKey(type)) || [];
};

const setAttribution = ({type, sourceAttribution}) => {
    const CAP = getCAP(type);
    sourceAttribution = sourceAttribution.sort(sortAttribution).slice(0, CAP);
    localStorage.setItem(getStorageKey(type), sourceAttribution);
};

const clearAttribution = type => {
    localStorage.deleteItem(getStorageKey(type));
};

const prepareToSave = element => {
    delete element.time;
    return element;
};

const addPage = ({type, page}) => {
    const sourceAttribution = getAttribution(type);
    const index = sourceAttribution.findIndex(({utmParams: {landingPage}}) => landingPage === page);

    if (index > -1) {
        const attributionElement = sourceAttribution[index];
        const visitCount = attributionElement.utmParams.visitCount + 1;

        Object.assign(attributionElement, getDateTime());
        Object.assign(attributionElement.utmParams, {visitCount});
    } else {
        const atribution = generateAttribution({type, page});
        sourceAttribution.push(atribution);
    }

    setAttribution({type, sourceAttribution});
};

const sourceAttributionHelper = {

    TYPE: {
        PRE_REGISTRATION_PAGE_VISIT: 'PRE_REGISTRATION_PAGE_VISIT'
    },

    saveHistory({type}) {
        if (User.loggedIn()) {
            const userId = User.getUserId();
            const endpoint = serviceFetchWrappers.addTokenToUrl(endpoints.userSourceAttribution(userId));
            const sourceAttribution = getAttribution(type).map(prepareToSave);

            return serviceFetchWrappers.fetchWrapper(endpoint, serviceFetchWrappers.addHeaders({
                method: 'POST',
                body: JSON.stringify({elementList: sourceAttribution})
            }))
            .then(() => clearAttribution(type));
        }

        return Promise.resolve();
    },

    trackPreRegistrationPageVisit() {
        if (!User.loggedIn()) {
            const type = this.TYPE.PRE_REGISTRATION_PAGE_VISIT;
            const page = windowCheck.location.pathname;
            addPage({type, page});
        }
    }

};

module.exports = sourceAttributionHelper;



// WEBPACK FOOTER //
// ./assets/js/global/utils/sourceAttributionHelper.es.js